import React from 'react';

const Table = ({
  id,
  data = [],
  columns,
  summary,
  reconstructorFn,
  checkedItems = [],
  setCheckedItems,
  setRowHovered,
  hasCheckbox = true,
  totalCount = null,
  onSelectAllRecords = null,
  checkedAllUsers = false,
  nameOfRecord = 'User'
}) => {
  const handleItemChecked = (itemId, itemEmail) => {
    const itemIndex = checkedItems.findIndex((item) => item.id === itemId);
    const isCurrentlyChecked = checkedAllUsers || itemIndex !== -1;
    
    if (isCurrentlyChecked) {
      if (checkedAllUsers) {
        if (onSelectAllRecords) {
          onSelectAllRecords(false);
        }
        const currentPageItems = data.map((item) => {
          const row = reconstructorFn(item);
          return { id: row.id, email: row.email };
        }).filter((item) => item.id !== itemId);
        
        const itemsFromOtherPages = checkedItems.filter(
          (item) => !data.some((d) => {
            const r = reconstructorFn(d);
            return r.id === item.id;
          })
        );
        
        setCheckedItems([...itemsFromOtherPages, ...currentPageItems]);
      } else {
        setCheckedItems(checkedItems.filter((item) => item.id !== itemId));
      }
    } else {
      setCheckedItems([...checkedItems, { id: itemId, email: itemEmail }]);
    }
  };

  const handleCheckAll = (event) => {
    if (event.target.checked) {
      const currentPageItems = data.map((item) => {
        const row = reconstructorFn(item);
        return { id: row.id, email: row.email };
      });

      const newCheckedItems = currentPageItems.filter(
        (item) => !checkedItems.some((checkedItem) => checkedItem.id === item.id)
      );

      setCheckedItems([...checkedItems, ...newCheckedItems]);
    } else {
      const currentPageRowIds = data.map((item) => {
        const row = reconstructorFn(item);
        return row.id;
      });
      
      const remainingCheckedItems = checkedItems.filter(
        (checkedItem) => !currentPageRowIds.includes(checkedItem.id)
      );
      setCheckedItems(remainingCheckedItems);
      if (onSelectAllRecords) {
        onSelectAllRecords(false);
      }
    }
  };

  const countCheckedItemsOnCurrentPage = () => {
    if (checkedAllUsers) {
      return data.length;
    }
    
    return data.reduce((count, item) => {
      const row = reconstructorFn(item);
      if (checkedItems.some((checkedItem) => checkedItem.id === row.id)) {
        return count + 1;
      }
      return count;
    }, 0);
  };
  return (
    <>
    {totalCount > 0 && checkedItems.length > 0 && (
      <div className="flex items-center gap-4 ml-4 mb-4">
        {(checkedAllUsers === null || checkedAllUsers === false) ? (
          <p
            className="text-sm underline cursor-pointer text-purple-600 font-semibold"
            onClick={() => onSelectAllRecords(true)}
          >
            Select {totalCount > 1 ? 'All' : ''} {totalCount.toLocaleString('en-US')} {totalCount > 1 ? nameOfRecord + 's' : nameOfRecord}
          </p>
        ) : (
          <p
            className="text-sm underline cursor-pointer text-purple-600 font-semibold"
            onClick={() => onSelectAllRecords(false)}
          >
            Unselect {totalCount > 1 ? 'All' : ''} {totalCount.toLocaleString('en-US')} {totalCount > 1 ? nameOfRecord + 's' : nameOfRecord}
          </p>
        )}
      </div>
    )}
      <table className="react-table rounded-lg">
        <thead className="bg-white-faint">
        <tr>
          {hasCheckbox && (
            <th className="checkbox-container">
              <label htmlFor={`${id}-check-all`}>
                <input
                  id={`${id}-check-all`}
                  type="checkbox"
                  checked={
                    checkedAllUsers ||
                    (countCheckedItemsOnCurrentPage() === data.length &&
                    data.length > 0)
                  }
                  onChange={handleCheckAll}
                />
              </label>
            </th>
          )}
          {columns.map((col, index) => {
            return (
              <th
                key={`header-${col.field || index}`}
                style={{ width: col.width, minWidth: col.width, whiteSpace: 'nowrap' }}
                className={`font-normal text-charcoal  text-${col.textAlign}`}
              >
                {col.label}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {data.map((curr, tableIndex) => {
          const row = reconstructorFn(curr);
          const checked = checkedAllUsers || checkedItems.some(
            (checkedItem) => checkedItem.id === row.id
          );
          return (
            <tr
              key={`${id}-row-${row.id}-${tableIndex}`}
              className={checked ? 'bg-purple-100' : ''}
              onMouseEnter={() => setRowHovered && setRowHovered(row.id)}
              onMouseLeave={() => setRowHovered && setRowHovered()}
            >
              {hasCheckbox && (
                <td className="text-center checkbox-container">
                  <label htmlFor={row.id}>
                    <input
                      id={row.id}
                      type="checkbox"
                      value={row.id}
                      checked={checked}
                      onChange={() => handleItemChecked(row.id, row.email)}
                    />
                  </label>
                </td>
              )}
              {columns.map((col, columnIndex) => (
                <td
                  key={`${row.id}-${col.field || columnIndex}`}
                  style={{ width: col.width, minWidth: col.width }}
                  className={`relative text-${col.textAlign} font-${col.fontWeight}`}
                >
                  {row[col.field]}{' '}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
      {summary && (
        <tfoot className="bg-white-faint font-bold">
          <tr>
            {summary.map((summaryItem, summaryIndex) => (
              <td key={`summary-${summaryIndex}`}>{summaryItem}</td>
            ))}
          </tr>
        </tfoot>
      )}
      </table>
    </>
  );
};

export default Table;